export default {
    goToFirstPage: 'Go to the first page',
    goToLastPage: 'Go to the last page',
    goToNextPage: 'Go to the next page',
    goToPreviousPage: 'Go to the previous page',
    items: 'items',
    pageRange: '{x} - {y} of {z} items',
};
